import { faEllipsisVertical, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import useLocalStorageState from 'use-local-storage-state';
import { UnauthViewModal } from '../../../../pages/UnauthViewModal';
import { Tasks } from '../../../Forms/Tasks';
import DeleteModal from '../../../DeleteModal';
import { DeleteRequest, GetRequest } from '../../../../Utils/hooks/ApiHandler';
import { formatDateInAlphabeticalMonth, formatTime, isDateTimePassed } from '../../../../Utils/helpers/commonhelper';
import { toast } from 'sonner';
import nodata from "../../../../Utils/assets/img/leads_no_data_found.png"
import { useNavigate } from 'react-router-dom';

export const ContactTasks = ({
    contactId,
    fullAddress,
    ownerId
}) => {
    const [customer, setCustomer] = useLocalStorageState("customer");
    const navigate = useNavigate()
    // Extract tokens from session
    const customerId = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const headers = {
        authentication: rf,
        Authorization: token,
    };
    const extras = { customer, setCustomer, rf, navigate };

    // state for delete task with task id
    const [taskId, setTaskId] = useState("");
    // set all tasks to display all task in the task tab
    const [allTask, setAllTask] = useState([]);
    // state for openining ofcanvas for edit task of a contact with coontact id
    const [editTask, setEditTask] = useState(false);
    // state for delete a task
    const [deleteTask, setDeleteTask] = useState(false)
    // loading state for delete task
    const [loading, setLoading] = useState(false)

    const [showDetails, setShowDetails] = useState(false);

    const charLimits = 57; // Change this to any limit you want
    const isTruncated = fullAddress.length > charLimits;
    const preview = fullAddress.slice(0, charLimits);
    const [expandedMap, setExpandedMap] = useState({});

    // permission setup for conntacts
    const permission = customer.customer_details?.permission
    const contactPermssion = permission?.filter(c => c.module_name === "contact")
    const user_type = Number(customer.customer_details?.user_type)
    const contactTaskGrant = {
        isView: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "followup")?.delete)) : true,
    }


    // handle edit task function
    const handleEditTask = () => {
        setEditTask(true);
    };
    // handle delete task
    const handleDeleteTask = async () => {
        setLoading(true)
        try {
            const res = await DeleteRequest(
                `contacts/deleteTask/${taskId}`,
                { headers },
                { extras }
            );
            setLoading(false)
            await fetchAllTasks();
            setDeleteTask(false);
        } catch (error) {
            setLoading(false)
        }
    };
    // function for getting all tasks
    const fetchAllTasks = async () => {
        const taskResponse = await GetRequest(
            `contacts/fetchAllTasks/${contactId}/contact`,
            { headers },
            { extras }
        );
        setAllTask(taskResponse?.data);
        // if(taskResponse.status ==='success'){
        // }
    };
    // useEffect to fetch all task
    useEffect(() => {
        fetchAllTasks();
    }, []);


    // for date time color check function if due date is passed or not
    function TaskDueDate({ due_date, due_time }) {
        const [isOverdue, setIsOverdue] = useState(
            isDateTimePassed(due_date, due_time)
        );

        useEffect(() => {
            const interval = setInterval(() => {
                setIsOverdue(isDateTimePassed(due_date, due_time));
            }, 10 * 60 * 10);

            return () => clearInterval(interval);
        }, [due_date, due_time]);

        return (
            <span
                className={`title ${isOverdue ? "text-danger" : "text-black"}`}
            //  style={{ color: isOverdue ? "red" : "black" }}
            >
                {formatDateInAlphabeticalMonth(due_date)} at {formatTime(due_time)}
            </span>
        );
    }

    // function to update task date and time state
    function taskDueDate(due_date, due_time) {
        return <TaskDueDate due_date={due_date} due_time={due_time} />;
    }


    const toggleExpand = (id) => {
        setExpandedMap((prev) => ({
            ...prev,
            [id]: !prev[id], // toggle only that id
        }));
    };

    const hideShow = (id, contents, title) => {
        let charLimit;
        charLimit = title ? 50 : 98
        const isTruncated = contents.length > charLimit;
        const preview = contents.slice(0, charLimit);
        const expanded = expandedMap[id] || false;

        return (
            <>
                {expanded || !isTruncated ? contents : preview + "..."}
                {isTruncated && (
                    <span
                        onClick={() => toggleExpand(id)}
                        style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
                    >
                        {expanded ? "Less" : "More"}
                    </span>
                )}
            </>
        );
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-0 px-3">
                <div
                    className=" mb-0"
                    style={{ fontSize: "19px", fontWeight: "300" }}
                >
                    Task
                </div>
                <button
                    className="btn btn-default-outline"
                    style={styles.listButtonsStyles}
                    onClick={() => {
                        if (!contactTaskGrant.isCreate) {
                            toast.warning("You are not are not authorized for this action!")
                            return
                        }
                        setShowDetails(true)
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Add
                </button>
            </div>
            <hr
                className="mb-0"
                style={{ marginTop: "11px" }}
            />
            <div
                style={{
                    height: "30rem",
                    overflowY: "auto",
                    overflowX: "hidden",
                    scrollBehavior: "smooth",
                    scrollbarWidth: "thin"
                }}
                className="listStyleForContact"
                onMouseEnter={(e) => {
                    e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                }}
            >
                {
                    contactTaskGrant?.isView ?
                        allTask?.length > 0 ? allTask?.map((allTaskData) => {
                            return (
                                <div className="mt-3">
                                    <ul className="list-unstyled mb-0 card-list list-bordered">
                                        <li className="media border-bottom pt-2 pb-2 px-3">
                                            <div className="pr-2 w-10 flex-shrink-0"></div>
                                            <div className="media-body d-flex w-90">
                                                <div className="w-95 cursor-pointer">
                                                    <div
                                                        className="mb-20 mw-fit-content"
                                                        title=""
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        data-original-title="This is priority task, complete this quickly"
                                                    >
                                                        <p
                                                            className="card-list-content mb-0 text-primary line-height-2"
                                                            style={{
                                                                fontSize: 14,
                                                                fontWeight: 600,
                                                                whiteSpace: expandedMap[`${allTaskData.task_id}-title`] ? "normal" : "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                        >
                                                            {hideShow(
                                                                `${allTaskData.task_id}-title`,
                                                                allTaskData.name,
                                                                true
                                                            )}
                                                        </p>
                                                        <div
                                                            className="mb-3 line-height-2"
                                                            style={{
                                                                color: "black",
                                                                fontSize: 14,
                                                                wordBreak: "break-all",
                                                            }}
                                                        >
                                                            {hideShow(
                                                                `${allTaskData.task_id}-description`,
                                                                allTaskData.description || "No description available"
                                                                , false
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6 mb-3">
                                                            <div className="d-flex flex-column ">
                                                                <p
                                                                    className=" mb-0 cursor-pointer"
                                                                    style={styles.labels}
                                                                >
                                                                    Priority
                                                                </p>
                                                                <span
                                                                    className={`badge mt-1 text-capitalize
                                                        ${allTaskData.priority ===
                                                                            "high"
                                                                            ? "bg-danger"
                                                                            : allTaskData.priority ===
                                                                                "medium"
                                                                                ? "bg-success"
                                                                                : "bg-warning"
                                                                        }`}
                                                                    style={{
                                                                        width: "fit-content",
                                                                        borderRadius: 2,
                                                                        fontWeight: 400,
                                                                        padding: "3px 5px",
                                                                    }}
                                                                >
                                                                    {allTaskData.priority ||
                                                                        "-"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 mb-3">
                                                            <div className="d-flex flex-column read-only-info">
                                                                <p
                                                                    className="mb-0 cursor-pointer "
                                                                    style={styles.labels}
                                                                >
                                                                    Assigned To
                                                                </p>
                                                                <span className="title">
                                                                    {allTaskData.assigned_name ||
                                                                        "-"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 mb-3">
                                                            <div className="d-flex flex-column ">
                                                                <p
                                                                    className=" mb-0 cursor-pointer "
                                                                    style={styles.labels}
                                                                >
                                                                    Created By
                                                                </p>
                                                                <span className="title">
                                                                    {allTaskData.added_name ||
                                                                        "-"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-6  mb-3">
                                                            <div className="d-flex flex-column ">
                                                                <p
                                                                    className=" mb-0 cursor-pointer "
                                                                    style={styles.labels}
                                                                >
                                                                    Due Date
                                                                </p>
                                                                {taskDueDate(allTaskData.due_date, allTaskData.due_time.slice(0, 5))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="w-5 text-right mt-0">
                                                    <Dropdown className="dropdropdownsWithoutToggle">
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            style={{
                                                                border: "none",
                                                                background: "none",
                                                                padding: 0,
                                                            }}
                                                            className="dropdownTogglesBtns ms-3"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faEllipsisVertical}
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    if (!contactTaskGrant.isEdit) {
                                                                        toast.warning("You are not authorized for this action!")
                                                                        return
                                                                    }
                                                                    setEditTask(true);
                                                                    setTaskId(
                                                                        allTaskData.task_id
                                                                    );
                                                                }}
                                                            >
                                                                Edit
                                                            </Dropdown.Item>

                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    if (!contactTaskGrant.isDelete) {
                                                                        toast.warning("You are not authorized for this action!")
                                                                        return
                                                                    }
                                                                    setDeleteTask(true);
                                                                    setTaskId(
                                                                        allTaskData.task_id
                                                                    );
                                                                }}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            );
                        }) :
                            <div
                                class="d-flex justify-content-center align-items-center"
                                style={{ position: "absolute", left: "24%" }}
                            >
                                <img
                                    src={nodata}
                                    alt=""
                                    style={{ width: "17rem", marginTop: "0" }}
                                />
                            </div>
                        :
                        <UnauthViewModal tabName={"Task"} />
                }
            </div>
            {showDetails && ownerId && (contactId !== undefined || contactId !== null) && (
                <Tasks
                    ownerId={ownerId}
                    show={showDetails}
                    onCanvasClose={() => setShowDetails(false)}
                    contactId={contactId}
                    fetchAllTasks={fetchAllTasks}
                />
            )}
            {editTask && ownerId && (contactId !== undefined || contactId !== null) && (
                <Tasks
                    ownerId={ownerId}
                    show={editTask}
                    onCanvasClose={() => setEditTask(false)}
                    taskId={taskId}
                    editTask={editTask}
                    contactId={contactId}
                    fetchAllTasks={fetchAllTasks}
                />
            )}
            {deleteTask && (
                <DeleteModal
                    onConfirm={handleDeleteTask}
                    show={deleteTask}
                    onClose={() => setDeleteTask(false)}
                    isLoading={loading}
                    message={"Are you sure you want to delete this task"}
                />
            )}
        </>
    )
}

const styles = {
    listButtonsStyles: {
        fontSize: "13px",
        // borderBottom: '1px solid #e3e3e3',
        height: "30px",
        width: "auto",
        gap: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        color: "#fff",
    },
    labels: {
        fontSize: "12px",
        color: "#B0BAC9",
        fontWeight: 400,
    },
}